export const REGISTER_FORM_NAME = {
    TITLE : "title",
    FIRST_NAME : "firstName",
    LAST_NAME : "lastName", 
    GENDER : "gender",
    PHONE : "phone",
    USERNAME : "userName",
    PASSWORD : "password",
    CONFIRMATION_PASSWORD : "confirmPassword"
}